/**
 *  @class
 *  @function BeforeAfter
 */
if (!customElements.get('before-after')) {
	class BeforeAfter extends HTMLElement {
		constructor() {
			super();
			this.parent = this.closest('.before-after-image');
			this.slider = this.querySelector('.before-after-image--slider');
			this.container = this;
			this.position = this.slider.value;
			this.isDragging = false;
			
			const _this = this;
			this.observer = new IntersectionObserver(function(entries) {
				if (entries[0].intersectionRatio > 0) {
					gsap.to(_this.parent, {'--percent': `${_this.position / 10}%`, duration: 1.5, ease:"power2.out"});
					_this.observer.unobserve(_this);
				}
			},
			{
				threshold: [0, 1],
				rootMargin: '0% 0% -20% 0%'
			});
		}

		connectedCallback() {
			// Originele slider input event
			this.slider.addEventListener('input', this.onInput.bind(this));
			
			// Mouse events voor desktop
			this.container.addEventListener('mousedown', this.handleMouseDown.bind(this));
			document.addEventListener('mousemove', this.handleMouseMove.bind(this));
			document.addEventListener('mouseup', this.handleMouseUp.bind(this));
			
			// Touch events voor mobiel
			this.container.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
			this.container.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
			this.container.addEventListener('touchend', this.handleTouchEnd.bind(this));
			
			// Voorkom text selectie tijdens dragging
			this.container.style.userSelect = 'none';
			this.container.style.webkitUserSelect = 'none';
			this.container.style.cursor = 'ew-resize';
			
			// Originele animatie logic
			if (document.body.classList.contains('animations-true')) {
				this.parent.style.setProperty('--percent', '0%');
				this.observer.observe(this);
			}
		}

		// Originele input handler
		onInput() {
			this.parent.style.setProperty('--percent', `${this.slider.value / 10}%`);
		}

		// Hulp functie om X positie te krijgen
		getXPosition(event) {
			const rect = this.container.getBoundingClientRect();
			const clientX = event.type.includes('touch') ? event.touches[0].clientX : event.clientX;
			const x = clientX - rect.left;
			return Math.max(0, Math.min(x, rect.width));
		}

		// Update positie en slider waarde
		updatePosition(x) {
			const rect = this.container.getBoundingClientRect();
			const percentage = (x / rect.width) * 100;
			const clampedPercentage = Math.max(0, Math.min(100, percentage));
			const sliderValue = clampedPercentage * 10; // Slider gaat van 0-1000
			
			// Update CSS variabele
			this.parent.style.setProperty('--percent', `${clampedPercentage}%`);
			
			// Update slider waarde (zonder event te triggeren)
			this.slider.value = sliderValue;
			this.position = sliderValue;
		}

		// Mouse event handlers
		handleMouseDown(event) {
			event.preventDefault();
			this.isDragging = true;
			const x = this.getXPosition(event);
			this.updatePosition(x);
			document.body.style.cursor = 'ew-resize';
		}

		handleMouseMove(event) {
			if (!this.isDragging) return;
			event.preventDefault();
			const x = this.getXPosition(event);
			this.updatePosition(x);
		}

		handleMouseUp(event) {
			if (!this.isDragging) return;
			this.isDragging = false;
			document.body.style.cursor = '';
		}

		// Touch event handlers
		handleTouchStart(event) {
			event.preventDefault(); // Voorkom scrolling
			this.isDragging = true;
			const x = this.getXPosition(event);
			this.updatePosition(x);
		}

		handleTouchMove(event) {
			if (!this.isDragging) return;
			event.preventDefault(); // Voorkom scrolling
			const x = this.getXPosition(event);
			this.updatePosition(x);
		}

		handleTouchEnd(event) {
			if (!this.isDragging) return;
			this.isDragging = false;
		}
	}
	customElements.define('before-after', BeforeAfter);
}